import { MatchMode } from '../../types/types';
import { processFilterMatchMode } from '../processFilterMatchMode';

// Converts a single { matchMode: value } filter entry to its server form.
export const processFlatFilter = (filter: Record<string, any>) => {
  const matchMode = Object.keys(filter)[0] as MatchMode;
  return processFilterMatchMode(matchMode, filter[matchMode]);
};
